import Tool, { type ITool } from "./Tool";

type PreviewOptions = never;

class PreviewTool extends Tool implements ITool<PreviewOptions> {
  activate() {
    if (!this.canvas) return;

    this.canvas.isDrawingMode = false;
  }

  deactivate() {
    this.canvas = null;
  }

  updateOptions!: () => undefined;
}

export default PreviewTool;
